import {
  SupplierStorefrontV2GetParametersType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2ListParams,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierStorefrontV2 = <
  TData = SupplierStorefrontV2GetResponseType,
>(
  supplierId: number,
  params: ApiV2ListParams & SupplierStorefrontV2GetParametersType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.SupplierStorefrontV2,
      supplierId,
      params,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `suppliers/${supplierId}/storefront/v2`,
        params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
